<template>
  <div class="ndetails">
    <div class="details litigation-details">
      <a-spin :spinning="loading">
        <div class="maindetails">
          <a-button class='debdel' @click='debDel($route.params.id)'
            v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:del")'>删除</a-button>
          <div class="dislogbox">
            <File ref='filelist' v-if='dislog.filelist' :type="FileType"></File>
            <!-- 基本信息附件 -->
            <FileHistory :List='debInfo.keep' ref='FileHistory' :clear='debInfo.is_clear' v-if='dislog.FileHistory'>
            </FileHistory>
            <!--保全记录 -->
            <Call ref='call' v-if='dislog.call' :clear='debInfo.is_clear'></Call>
            <!-- 催收记录 -->
            <Laysuit ref='Laysuit' :info='LaysuitInfo'></Laysuit>
            <!-- 案件 -->
            <StepSel :Step='Step' ref='stepbox'
              @lite='(element) => { $store.dispatch("setkey", { key: "Edit", value: false }); visibleShow(element) }'>
            </StepSel>
            <Beforetime ref='beforetime' v-if='dislog.beforetime'></Beforetime>
            <Beforestart ref='beforestart' v-if='dislog.beforestart'></Beforestart>
            <Police ref='police' v-if='dislog.police'></Police>
            <Ones ref='ones' v-if='dislog.ones'></Ones>
            <!--一审立案审查中  二审立案审查-->
            <Twos ref='twos' v-if='dislog.twos'></Twos><!-- 一审诉调中 -->
            <Three ref='three' v-if='dislog.three'></Three><!-- 一审立案  二审立案 执行立案 -->
            <Four ref='Fours' v-if='dislog.Fours'></Four><!-- 一审待开庭 二审待开庭 -->
            <Five ref='Five' v-if='dislog.Five'></Five><!-- 一审待判决 二审待判决 -->
            <Six ref='Six' v-if='dislog.Six'></Six><!-- 判决文书 二审裁决书-->
            <Fiveteen ref='Fiveteen' v-if='dislog.Fiveteen'></Fiveteen> <!-- 执行中 -->
            <Reason ref='reason' v-if='dislog.reason'></Reason> <!-- 作废原因 -->
            <!-- 延期记录 -->
            <InvalidTable ref='InvalidTable' v-if='$store.state.cause.id && hasjdList' :Step='hasjdList'></InvalidTable>
            <a-modal :visible="formVis" @cancel="formVis = false" title='延期天数' width='460px' @ok='visSub'>
              <a-row align='middle' justify='space-between' type='flex' style="margin-bottom:10px;">
                <label>延期天数：</label>
                <a-input placeholder='请输入延期天数' v-model='smlform.day' type='number' style="width:340px;"> </a-input>
              </a-row>
              <a-row align='middle' justify='space-between' type='flex'>
                <label>延期原因：</label>
                <a-input placeholder='请输入延期原因' v-model='smlform.reason' style="width:340px;"> </a-input>
              </a-row>
            </a-modal>
          </div>
          <div class="card wbg">
            <img class="clearfa" src="../../assets/img/jqpic_03.png" v-if="debInfo.is_clear == 1" width="132" />
            <div class="htit">
              <div class="h2">债务人信息</div>
              <div class="rt">
                <router-link :to='{ "name": "newly", query: { id: $route.params.id } }'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:edit") && debInfo.is_clear != 1'>
                  <a-button type="primary" icon="edit">修改债务人信息 </a-button>
                </router-link>
                <a-button icon="paper-clip" style="margin-left:20px;" type="primary" ghost @click='seeFile(0)'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:files")'>附件汇总 </a-button>
                <a-button icon="paper-clip" style="margin-left:20px;" type="primary" ghost @click='seeFile(1)'>沟通附件汇总
                </a-button>
                <a-button icon="save" style='margin-left:20px;' type="primary" ghost @click='visibleShow("FileHistory")'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:keep:index")'>保全记录 </a-button>
                <!-- <a-button icon="phone" style='margin-left:20px;' type="primary" ghost @click='visibleShow("call")' v-if='$common.AccAUTH(debInfo.accuser_id,"debtor:urge:index")'>催收记录</a-button> -->
                <!-- <a-button icon='money-collect'  @click='clearP' type="primary" ghost style="display:inline-block;margin-left:20px;" v-if='$common.AccAUTH(debInfo.accuser_id,"debtor:setClear")'  :class='{"gre":debInfo.myclear===1}'>{{debInfo.myclear==1?'银行已结清':'银行结清'}}</a-button> -->
              </div>
            </div>
            <Basic></Basic>
          </div>
          <div v-if="$store.state.cause.id && comLoad">
            <div class="card wbg">
              <OtherList></OtherList><!-- 其他债务人信息 -->
            </div>
            <div class="card wbg" v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:index")'>
              <CarList></CarList> <!-- 案涉标的物信息 -->
            </div>
          </div>
          <div class="card wbg">
            <div class="htit htit1" style="margin:0;">
              <div class="h2">案件信息</div>
              <div class="rt">
                <a-button type="primary" icon="plus" @click='deAdd'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "cause:add") && debInfo.is_clear != 1'
                  style="margin-right:20px;">添加案件</a-button>
                <a-button type="danger" @click='delsu(1)'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "cause:invaild") && $store.state.cause.invaild != 1 && caselist.length > 0'>
                  作废
                </a-button>
                <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='delsu(0)'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "cause:delete") && debInfo.is_clear != 1 && caselist.length > 0'>
                  <a-button type="danger" style="margin-left:20px;background:#A4B5C7;border-color:#A4B5C7;">
                    删除
                  </a-button>
                </a-popconfirm>
              </div>
            </div>
            <a-tabs class="tab-wrap" @change='(id) => { init(id) }' v-model="causeId">
              <a-tab-pane :tab="'案件' + i.sort" v-for='(i, index) in caselist' :key='i.id'>
                <div style="width:100%;overflow:hidden;"
                  v-if='caselist.length > 0 && ($common.AccAUTH(i.accuser_id, $store.state.cause.invaild == 0 ? "cause:lists" : "cause:lists:invaild"))'>
                  <div class="insetbox">
                    <div class="htit" style="border:0 none;">
                      <div class="h3">
                        <h3 style="margin:0;">案件基础信息&nbsp;&nbsp;[{{ i.cause_type == 1 ? '诉讼' : '调解' }}]</h3>
                        <a-select style="min-width: 100px;" size="small" v-model="agent_model" placeholder="请选择"
                          class="nselect" @change='agCk($event, index)'
                          v-if='$store.state.user.id <= 1 || ($common.AccAUTH(i.accuser_id, "cause:agentModel:read") && debInfo.is_clear != 1 && $store.state.cause.invaild != 1)'
                          :disabled='!$common.AccAUTH(i.accuser_id, "caue:agentModel:edit")'>
                          <a-select-option v-for="i in agencyList" :key="i.id">{{ i.title }}</a-select-option>
                        </a-select>
                        <span style="margin-left:20px;">当前负责人:</span>
                        <a-select style="min-width: 120px;" size="small"
                          :value="i.step_user_id === 0 ? null : i.step_user_id" placeholder="当前负责人" class="nselect"
                          show-search option-filter-prop="children" :filter-option="filterOption"
                          @change="setStepUser($event, i)">
                          <a-select-option v-for="i in userList" :key="i.id">{{ i.uname }}</a-select-option>
                        </a-select>
                      </div>
                      <div class="rt">
                        <a-button v-if="i.has_loan" icon="money-collect" style="margin-right: 20px;"
                          @click="dbclick(i)">分期信息</a-button>
                        <a-button v-if="i.has_payee" icon="transaction" style="margin-right: 20px;"
                          @click="collectionClick(i)">回款信息</a-button>
                        <Share v-if='$common.AccAUTH(i.accuser_id, "Infomation:share")'></Share>
                        <a-button type="primary" ghost icon="edit" @click='LaysuitInfo = i; visibleShow("Laysuit");'
                          v-if='$store.state.user.id <= 1 || ($common.AccAUTH(i.accuser_id, "cause:edit") && debInfo.is_clear != 1 && $store.state.cause.invaild != 1)'>修改</a-button>
                      </div>
                    </div>
                    <CaseInfo v-if="$store.state.cause.id && comLoad" :i="i" :hasjdList="hasjdList" :index="index">
                    </CaseInfo>
                  </div>
                  <div class="insetbox"
                    v-if='$common.AccAUTH(i.accuser_id, $store.state.cause.invaild != 1 ? "true" : "cancel.cause.communication.view")'>
                    <HisList :accuser_id="i.accuser_id" :is_clear="debInfo.is_clear"
                      v-if="i.accuser_id && $store.state.cause.id && comLoad"></HisList>
                  </div>
                  <div class="solids" style="margin-top:20px;"></div>
                  <Auction
                    v-if="$store.state.cause.id && comLoad && $common.AccAUTH($store.state.cause.accuser.id, 'debinfo:auction:index')">
                  </Auction>
                  <div class="solids" style="margin-top:20px;"></div>
                  <div class="insetbox jdmbox"
                    v-if="$common.AccAUTH(i.accuser_id, $store.state.cause.invaild == 0 ? 'stepbar:lists' : 'cause:invaild:step:lists')">
                    <div class="htit hspan">
                      <div class="h2">案件进度
                        <!-- <i class="oings" v-if='i.in_loan==1'>分期还款履行中</i> -->
                      </div>
                      <div class="rt">
                        <a-button type="primary" icon="plus" @click='visibleShow("stepbox")' style="margin-right:20px;"
                          v-if='$common.AccAUTH(i.accuser_id, "cause:step:ja:add") || !$store.state.editJA'>添加进度</a-button>
                        <a-button @click='$refs.InvalidTable.visible = true;' ghost type="primary"
                          v-if='$store.state.cause.invaild != 1 && $common.AccAUTH(i.accuser_id, "step:delay:history")'>延期记录</a-button>
                      </div>
                    </div>
                    <div class="inboxset">
                      <div class="stepbox" v-for='(i, index) in Step' :key='index'>
                        <div class="steps-item" v-for='(j, ind) in i' :key='ind'
                          :class='{ "over": j.isover, "ant-steps-item-wait": !j.isover }' v-if="j.lite != 181">
                          <div class="tit" :style='{ "margin-left": pxDw(j.name) + "px" }'>
                            <div class="name">
                              {{ j.name }}
                              <span v-if='j.remind' v-html='rTime(j.remind)'></span>
                            </div>
                            <div class="time">{{ j.time | yearFormats }}</div>
                            <a href='javascript:void(0);' v-if='j.isover'
                              @click='seeStep(j.element, j.lite, j.keyName, j)'>查看</a>
                            <!-- :overlayStyle="{
                            maxHeight: '500px',
                            overflow: 'auto'
                            }" -->
                            <a-popover :mouseEnterDelay="0.5" title="延期记录" v-if='j.remind'>
                              <template slot="content">
                                <div class="table stepsTable" style="max-height: 500px;overflow-y: auto;">
                                  <table>
                                    <thead>
                                      <td>原延期日期</td>
                                      <td>现延期日期</td>
                                      <td>延期理由</td>
                                    </thead>
                                    <tbody>
                                      <tr v-for='k in j.remind.over_comment'>
                                        <td>{{ k.originDate }}</td>
                                        <td>{{ k.overDate | yearFormats }}</td>
                                        <td>
                                          <Tooltip :tit='k.reason'></Tooltip>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </template>
                              <a href='javascript:void(0);' style="margin-left:10px;"
                                @click='smlform.id = j.remind.id; smlform.day = null; smlform.reason = null; formVis = true;'
                                v-if='$store.state.cause.invaild == 0 && $common.AccAUTH($store.state.cause.accuser.id, j.keyName + ":delayed") && !$store.state.editJA'>延期</a>
                            </a-popover>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="solids"></div>
                  <div class="incbox" v-if='causeId && !loading'>
                    <div class="smlbox" v-if='credit && $common.AccAUTH(i.accuser_id, "dktFee:do")'>
                      <Count :Proposition='credit' title='主张债权及费用计算' :type='false' :payee='i.payee'
                        :seeCapital='Number(i.capital)||0' :used_fee="i.used_fee" @resh='init($store.state.cause.id, "resh")'>
                      </Count>
                    </div>
                    <div class="smlbox"
                      v-if='Postcredit && credit && $common.AccAUTH(i.accuser_id, "cause:credit:lists")'>
                      <Count :type='true' title='确认债权及费用计算' :Proposition='Postcredit' :Credit='credit'
                        :payeeFee="i.payee_fee" @resh='init($store.state.cause.id, "resh")' :seeCapital='Number(i.capital)||0'
                        :used_fee="i.used_fee" :bankFee="i.bank_clear_fee"></Count>
                    </div>
                  </div>
                  <Out :Proposition='credit' :outList="outList"
                    v-if="outList.length && credit && $common.AccAUTH(i.accuser_id, 'return:read')"></Out>
                  <div class="solids"></div>
                </div>
                <CauseStepLog :id='causeId' v-if='causeId'></CauseStepLog> <!-- 操作记录 -->
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </a-spin>
    </div>
  </div>
</template>
<script>
import { dateFormat } from "@/assets/js/formData"
import { mapGetters, mapActions } from 'vuex'
import { debtorDel } from '@/server/debtor'
import { causeStep, stepCredit, debtorClear, delCause, Delay, refundList } from "@/server/api"
import { accUserList, causeStStepUser } from '@/server/user'
import { agencyList } from '@/server/directory'
import cmps from './reg'
import Step from "./step.json"      //进度json
import artStep from "./artStep.json"      //进度json
import Proposition from "./stepCredit.json"     //债券列表
import { Tooltip } from "ant-design-vue"
export default {
  components: {
    ...cmps
  },
  data() {
    return {
      userList: [],    //用户列表
      agencyList: [],
      agent_model: '',
      formVis: false,
      outList: [],
      causeId: 0,
      FileType: 0,   //0 普通附件 1沟通记录附件
      smlform: {
        day: '',
        reason: ''
      },
      // isAllDis: this.$route.query.t,
      OtherInfo: {}, //单个其他债务人详情
      loading: true,      //加载
      hasjdList: [],
      Step: {},
      comLoad: false,
      credit: null,        //主张债权
      Postcredit: null,
      LaysuitInfo: {}, //当前案件

    }
  },
  computed: {
    time() {
      return dateFormat(new Date())
    },
    ...mapGetters([
      'caselist',        //案件列表
      'debInfo',
      'dislog'
    ])
  },
  created() {
    console.log('store',this.$store.state);
    
    this.getList({
      "debtor_id": this.$route.params.id
    }).then(e => {
      if (e.length > 0) {

        //this.$store.dispatch("setkey", { key: "cause", value: e[0] })
        const sort = this.$route.query.e * 1 - 1 || 0
        this.causeId = e[sort].id
        this.causeIndex = e.list
        this.Postcredit = this.rPropo(e[sort].credit)
        // e[sort].id为进度id
        this.init(e[sort].id)
      } else {
        this.loading = false;
      }
    })
    this.getInfo({          //
      "id": this.$route.params.id
    })
    agencyList().then(res => {
      this.agencyList = res.list
    })

    accUserList({ is_inner: 1 }).then(e => {
      this.userList = e.list
    })
  },
  filters: {
    nAccId() {
      return this.$store.state.cause.accuser_id || this.debInfo.id
    },
    rStatus(val) {
      let keyjson = { 1: "待审核", 2: "审核通过", 3: "审核拒绝" }
      return keyjson[val]
    }
  },
  methods: {
    seeFile(type) {
      this.FileType = type
      this.visibleShow("filelist")
    },
    setStepUser(value, item) {
      item.step_user_id = value || 0;
      causeStStepUser({ cause_id: item.id, user_id: item.step_user_id }).then(e => {
        this.$message.success({ content: '设置成功', key: 'updatable' });
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    visSub() {
      Delay(this.smlform).then(e => {
        this.$message.success({ content: '延期操作已提交，待审核', key: 'updatable' });
        this.init(this.$store.state.cause.id)
        this.formVis = false;
        setTimeout(e => {
          window.history.go(0)
        }, 500)
      })
    },
    rTime(val) {
      let fYear = (v) => {
        let days = v ? new Date(v).toLocaleDateString() : new Date().toLocaleDateString()
        return new Date(days).getTime()
      }
      if (val.over_date) {
        const today = fYear(),
          vTime = fYear(val.over_date);
        if (today >= vTime) {
          const day = parseInt((today - vTime) / 3600000 / 24)
          return `(<font color='#f00'> ${day + val.day}</font> / ${val.day} )`
        } else {
          const day = parseInt((vTime - today) / 3600000 / 24);
          let newDate = val.day - day
          return `(${newDate <= 0 ? 0 : newDate}/${val.day})`
        }
      } else {
        return ''
      }
    },
    dbclick(record) {
      if (this.$common.AUTH('loan:info:lists')) {
        let routeUrl = this.$router.resolve({ "name": "paybacksee", params: { "id": record.accused[0].id } });
        window.open(routeUrl.href, '_blank');
      }
      else {
        this.$message.error({ content: '暂无权限', key: 'updatable' });
      }
    },
    collectionClick(record) {
      if (this.$common.AUTH('payee:info:lists')) {
        let routeUrl = this.$router.resolve({ "name": "AmountSee", params: { "id": record.accused[0].id } });
        window.open(routeUrl.href, '_blank');
      }
      else {
        this.$message.error({ content: '暂无权限', key: 'updatable' });
      }
    }, debDel(id) {
      this.$modal.confirm({
        title: '确认删除此案件?',
        onOk: () => {
          debtorDel({ debtor_id: id }).then(e => {
            this.$message.success({ content: '删除' });
            this.$router.push({ name: 'newlylist' });
            // this.$router.back(-1)
          })
        }
      });
    },
    pxDw(unit) {
      let len = unit.length;
      const l = [0, 0, 30, 22, 14, 8, 2, 0, 0, 0, 0, 0]
      if (unit == "重审立案") return 0
      else return l[len]
    },
    deAdd() {
      let casev = JSON.parse(JSON.stringify(this.caselist))
      const keys = ['accuser_id', 'team_id', 'chinaid', 'debtor_ids', 'court', 'court_id', 'bank_id']
      let info = casev.length > 0 ? casev[0] : { accused: [] }
      info.accuser_id = null
      info.id = null
      this.LaysuitInfo = info
      this.visibleShow("Laysuit")
    },
    delsu(type) {
      const id = this.$store.state.cause.id
      // console.log(type)
      if (type == 0) {
        delCause({ cause_id: id }).then(e => {
          this.$message.success({ content: '已删除', key: 'updatable' });
          setTimeout(e => {
            window.history.go(0)
          }, 1000)
        })
      } else {
        this.visibleShow("reason")
      }
    },
    rPropo(Arr) {
      let newArr = []
      Object.keys(Proposition).map(item => {
        let isInclude = Arr.some(it => {
          return it.type == item
        })
        if (isInclude == false) {
          newArr.push({
            type_title: Proposition[item],
            type: item * 1,
            fee: 0
          })
        } else {
          newArr.push(Arr.filter(ele => { return ele.type == item })[0])
        }
      })
      return newArr
    },
    async postMain(id, resh) {
      if (resh) {
        this.getList({
          "debtor_id": this.$route.params.id
        }).then(e => {
          if (e.length > 0) {
            let credit = e.filter(ele => { return ele.id == id })[0].credit
            this.Postcredit = this.rPropo(credit)
          } else {
            this.loading = false;
          }
        })
      } else {
        let credit = this.caselist.filter(ele => { return ele.id == id })[0].credit
        this.Postcredit = this.rPropo(credit)
      }
    },
    clearP() {
      this.$store.dispatch('setkey', { key: 'StepLite', value: 181 })
      this.$store.dispatch('setkey', { key: 'StepKey', value: 'audit:debtorClear' })
      this.$store.dispatch("setkey", { key: "Edit", value: this.debInfo.clear });
      this.visibleShow("Fiveteen")
    },
    agCk(val, index) {
      if (this.$store.state.user.id <= 1 || (this.$common.AccAUTH(this.$store.state.cause.accuser.id, "caue:agentModel:edit") && this.debInfo.is_clear != 1 && this.$store.state.cause.invaild != 1)) {
        this.loading = true;
        this.$Ajax({
          url: "cause/editAgentModel",      //url 
          type: "put",
          data: { id: this.$store.state.cause.id, agent_model: val },
          success: (e) => {
            this.$message.success('修改成功')
            this.$store.dispatch('Case/putInData', { index: index, key: "agent_model", value: val })
            this.loading = false
          },
          fail: (e) => {
            this.loading = false
          }
        })
      } else {
        this.$message.error('暂无权限')
      }
    },
    async init(id, resh, causeType) {
      this.comLoad = false;
      await this.postMain(id, resh)
      this.causeId = null
      this.comType = 1;
      await causeStep({ cause_id: id }).then(e => {     //进度
        const cause = this.caselist.filter(ele => { return ele.id == id })[0]
        if (cause.step_user_id == 0) {
          cause.step_user_id = null
        }
        this.$store.dispatch("setkey", { key: "cause", value: cause })
        const stepJSON = cause.cause_type == 1 ? Step : artStep;
        // console.log(stepJSON)
        let StepList = JSON.parse(JSON.stringify(stepJSON))
        for (let val in StepList) {
          StepList[val].map(element => {
            e.list.map(ele => {
              if (element.lite * 1 == ele.step) {
                element.isover = true;
                element.time = ele.create_time
                element.remind = ele.remind.over_date ? ele.remind : null
              }
            })
          })
        }
        let noverjA = e.list.filter(ele => {
          return ele.step == 180
        })
        this.$store.dispatch("setkey", { key: "editJA", value: noverjA.length >= 1 && this.$store.state.user.id > 1 })
        this.agent_model = cause.agent_model
        this.hasjdList = e.list;
        // const invaild = cause.invaild;
        // this.$store.dispatch("Debinfo/SetClear", invaild)
        this.Step = StepList
        this.causeId = id
        this.loading = false;
        this.comLoad = true
      })
      this.credit = null;
      const isValidDate = (date) => {
        return date instanceof Date && !isNaN(date.getTime())
      }
      await refundList({ cause_id: id }).then(res => {
        const list = res.list.length > 0 ? res.list.map(ele => {
          return {
            type: ele.type,
            fee: ele.fee / 100,
            time: ele.time,
            files: ele.files,
            comment: ele.comment,
            audit: ele.audit.length > 0,
            filesobj: {
              id: ele.files,
              origin_name: ele.file_origin_name,
              url: ele.file_url
            }
          }
        }) : [
          { "type": 1, "fee": '', "time": null, "files": "", "filesobj": {}, comment: "", audit: false },
          { "type": 2, "fee": '', "time": null, "files": "", "filesobj": {}, comment: "", audit: false },
          { "type": 3, "fee": '', "time": null, "files": "", "filesobj": {}, comment: "", audit: false }
        ]
        const rr = new Map()
        const rlist = list.filter((a) => !rr.has(a.type) && rr.set(a.type, 1))
        this.outList = rlist;
      })
      await stepCredit({ cause_id: id }).then(e => {
        this.credit = this.rPropo(e.list)
        this.loading = false;
      })
    },
    ...mapActions({
      getList: 'Case/getlist',
      getInfo: 'Debinfo/getInfo'
    }),
    seeStep(name, lite, keyName) {      //查看进度
      this.$store.dispatch("setkey", { key: "Edit", value: true })
      this.setStep(lite, keyName)
      // console.log(name, lite, keyName)
      setTimeout(e => {
        if (this.$common.AccAUTH(this.debInfo.accuser_id, this.$store.state.cause.invaild == 0 ? this.$store.getters.stepPower.see : 'cause:invaild:step:lists')) {
          this.visibleShow(name)
        }
        else {
          this.$message.error('暂无权限')
        }
      }, 200)

    },
    setStep(lite, keyName) {
      this.$store.dispatch("setkey", { key: "StepLite", value: lite })
      this.$store.dispatch("setkey", { key: "StepKey", value: keyName })
      // console.log(this.$store.state.StepLite);
    },
    visibleShow(name) {
      this.$store.dispatch("openkey", { key: name, by: true })
    },

  }
}
</script>
<style lang="less">
.tab-wrap {
  .ant-tabs-bar {
    margin-left: 20px;
  }
}

.ising {
  opacity: 0.3;
}

@import './index.less';
</style>